import React, {useEffect, useState} from "react";
import API from "../../apiService";
import moment from "moment";
import BlobPrint from "../component/BlobPrint";
import ReactPaginate from "react-paginate";

export default function HistoryRanap({detilPx, history}) {

    const [histories, setHistories] = useState([])
    const [show, setShow] = useState(false)
    const [datas, setDatas] = useState([])

    useEffect(() => {
        getHistories()
    }, [])

    const getHistories = async () => {
        const res = await API.get(
            "registration/inpatient/" + detilPx.patient_id
        )
        if (res.code === 200) {
            console.log(res.data)
            setHistories(res.data)
        }
    }

    const setAge = (d) => {
        var b = moment(d);
        var a = new Date();

        a = moment(a);

        var years = a.diff(b, "year");
        b.add(years, "years");

        var months = a.diff(b, "months");
        b.add(months, "months");

        var days = a.diff(b, "days");

        if (years !== 0 && months == 0 && days == 0) {
            return years + " Tahun (Hari Lahir Pasien)";
        } else if (years == 0 && months == 0) {
            return days + " Hari";
        } else if (years == 0 && days == 0) {
            return months + " Bulan";
        } else if (years == 0) {
            return months + " Bulan " + days + " Hari";
        } else {
            return years + " Tahun " + months + " Bulan " + days + " Hari";
        }
    }

    const onReload = () => {
        history.push("/pelayanan-ranap");
    }

    const changePage = async (e) => {
        const res = await API.get(
            "registration/history/" + detilPx.patients.id + "?page=" + e
        );
        if (res.code === 200) {
            setHistories(res.data.histories.data)
            setDatas(res.data.histories)
        }
    }

    let patient = detilPx;
    let Age = setAge(patient.patients.birth_date);

    const build_pelayanan_utama = inp_rooms => {

        let details = inp_rooms.map(v => v.details).reduce((a, b) => a.concat(b), [])
        details.sort(function(a, b) {
            var keyA = new Date(a.created_at),
                keyB = new Date(b.created_at);
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        return (
            <table className="table table-bordered col-md-12 table-responsive">
                <tbody>
                <tr className="bg-secondary">
                    <th style={{padding: "12Px"}} colSpan={2} rowSpan={2}>
                        <div className="text-black text-center h4">
                            PELAYANAN UTAMA
                        </div>
                    </th>
                    {
                        inp_rooms.map(inp_room => (
                            <th style={{padding: "12Px"}} colSpan={inp_room.details.length}>
                                <div className="text-black text-center h4">
                                    {inp_room.room.name}
                                </div>
                            </th>
                        ))
                    }
                </tr>
                <tr className="bg-secondary">
                    {details.map(v => (
                        <th style={{padding: "12Px"}}>
                            <div className="text-black text-center h4">
                                {v.created_at}
                            </div>
                        </th>
                    ))}
                </tr>
                <tr>
                    <th style={{padding: "12Px"}} rowSpan={2}>
                        {" "}
                        SUBJECTIVE{" "}
                    </th>
                    <td style={{padding: "12Px"}}>Anamnese Dokter</td>
                    {details.map(v => (
                        <td style={{padding: "12Px"}}>
                            {v.anamneses.length ? v.anamneses[0].anamnese : ''}
                        </td>
                    ))}
                </tr>
                <tr>
                    <td style={{ padding: "12Px" }}>Anamnese Perawat</td>
                    {details.map(v => (
                        <td style={{padding: "12Px"}}>
                            {v.anamneses.length ? v.anamneses[0].nursing_anamnese : ''}
                        </td>
                    ))}
                </tr>
                <tr>
                    <th style={{ padding: "12Px" }} rowSpan={4}>
                        {" "}
                        OBJECTIVE{" "}
                    </th>
                    <td style={{ padding: "12Px" }}>Physic</td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            {" "}
                            Berat badan :{" "}
                            {v.examinations[0] ? v.examinations[0].weight : ""}{" "}
                            <br />
                            Tinggi Badan :{" "}
                            {v.examinations[0] ? v.examinations[0].height : ""}
                        </td>
                    ))}
                </tr>
                <tr>
                    <td style={{ padding: "12Px" }}>Vital Sign</td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            Tekanan darah :{" "}
                            {v.examinations[0]
                                ? v.examinations[0].sistole
                                : ""}{" "}
                            /{" "}
                            {v.examinations[0]
                                ? v.examinations[0].diastole
                                : ""}{" "}
                            <br />
                            Suhu :{" "}
                            {v.examinations[0]
                                ? v.examinations[0].temperature
                                : ""}{" "}
                            <br />
                            Nadi :{" "}
                            {v.examinations[0]
                                ? v.examinations[0].pulse
                                : ""}{" "}
                            <br />
                            Pernafasan :{" "}
                            {v.examinations[0]
                                ? v.examinations[0].respiration
                                : ""}{" "}
                            <br />
                            Golongan Darah :{" "}
                            {v.examinations[0] && v.examinations[0].blood ? v.examinations[0].blood.name : ''}
                        </td>
                    ))}
                </tr>
                <tr>
                    <td style={{ padding: "12Px" }}>
                        Pemeriksaan Fisik
                    </td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            Keadaan umum : <br />
                            <br />
                            Kepala :{" "}
                            {v.examinations[0]
                                ? v.examinations[0].kepala
                                : ""}{" "}
                            <br />
                            Leher :{" "}
                            {v.examinations[0]
                                ? v.examinations[0].leher
                                : ""}{" "}
                            <br />
                            Dada :{" "}
                            {v.examinations[0]
                                ? v.examinations[0].dada
                                : ""}{" "}
                            <br />
                            Perut :{" "}
                            {v.examinations[0]
                                ? v.examinations[0].perut
                                : ""}{" "}
                            <br />
                            Alat Gerak :{" "}
                            {v.examinations[0]
                                ? v.examinations[0].ex_bawah
                                : ""}
                            <br />
                        </td>
                    ))}
                </tr>
                <tr>
                    <td style={{ padding: "12Px" }}>
                        {history.teeth_anamneses ? "Elemen Gigi" : ""}
                    </td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            {v.teeth_anamneses?.teeth_no}
                        </td>
                    ))}
                </tr>
                <tr>
                    <th style={{ padding: "12Px" }} rowSpan={2}>
                        {" "}
                        ASSESMENT{" "}
                    </th>
                    <td style={{ padding: "12Px" }}>Diagnosa Dokter</td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            {v.diagnoses.length > 0
                                ? v.diagnoses.map((s, y) => {
                                    return (
                                        <div
                                            key={y}
                                            style={{ color: s.log ? "red" : " " }}
                                        >
                                            {s.icd_code} - {s.icd_name}
                                        </div>
                                    );
                                })
                                : ""}{" "}
                        </td>
                    ))}
                </tr>
                <tr>
                    <td style={{ padding: "12Px" }}>
                        Diagnosa keperawatan
                    </td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            {v.nurse_diagnosis && v.nurse_diagnosis.length > 0
                                ? v.nurse_diagnosis.map((s, y) => {
                                    return (
                                        <div
                                            key={y}
                                            style={{ color: s.log ? "red" : " " }}
                                        >
                                            {s.icd_code} -{" "}
                                            {s.nurse_code?.nurse_diagnosis}
                                        </div>
                                    );
                                })
                                : ""}{" "}
                        </td>
                    ))}
                </tr>
                <tr>
                    <th style={{ padding: "12Px" }} rowSpan={6}>
                        {" "}
                        PLANNING{" "}
                    </th>
                    <td style={{ padding: "12Px" }}>Tindakan</td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            {v.treatments.length > 0
                                ? v.treatments.map((s, y) => {
                                    return (
                                        <div
                                            key={y}
                                            style={{
                                                color: s.log > 0 ? "red" : " ",
                                            }}
                                        >
                                            {s.treatment.name}{" "}
                                            {s.log > 0 ? "(dihapus)" : " "}
                                        </div>
                                    );
                                })
                                : ""}{" "}
                        </td>
                    ))}
                </tr>
                <tr>
                    <td style={{ padding: "12Px" }}>Pengobatan</td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            {v.prescribes.length > 0
                                ? v.prescribes.map((s, y) => {
                                    if (s.combination_name === "") {
                                        return (
                                            <div
                                                key={y}
                                                style={{
                                                    color: s.log > 0 ? "red" : " ",
                                                }}
                                            >
                                                {s.details.length > 0
                                                    ? s.details[0]?.drug.name +
                                                    " (" +
                                                    s.details[0]?.qty +
                                                    ")" +
                                                    " (" +
                                                    s.signa.name +
                                                    ")"
                                                    : ""}
                                                {s.details.length > 0
                                                    ? s.log > 0
                                                        ? "(dihapus)"
                                                        : " "
                                                    : " "}
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div
                                                key={y}
                                                style={{
                                                    color: s.log > 0 ? "red" : " ",
                                                }}
                                            >
                                                {"Nama Kombinasi : " +
                                                s.combination_name +
                                                " (" +
                                                s.combination_qty +
                                                ")" +
                                                " (" +
                                                s.signa.name +
                                                ")"}
                                                {s.log > 0 ? "(dihapus)" : " "}
                                                {s.details.map((x, y) => {
                                                    return (
                                                        <div
                                                            style={{
                                                                paddingLeft: "10px",
                                                            }}
                                                            key={y}
                                                        >
                                                            {"+ " +
                                                            x.drug.name +
                                                            " (" +
                                                            x.qty +
                                                            ")"}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        );
                                    }
                                })
                                : ""}
                        </td>
                    ))}
                </tr>
                <tr>
                    <td style={{ padding: "12Px" }}>Saran</td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            {" "}
                            {v.advices.length ? v.advices[0].advice : ""}{" "}
                        </td>
                    ))}
                </tr>
                <tr>
                    <td style={{ padding: "12Px" }}>Evaluasi</td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            {" "}
                            {v.advices.length ? v.advices[0].evaluation : ""}{" "}
                        </td>
                    ))}
                </tr>
                <tr>
                    <td style={{ padding: "12Px" }}>
                        Tindakan Keperawatan
                    </td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            {" "}
                            {v.anamneses.length > 0
                                ? v.anamneses[0].treat
                                : ""}{" "}
                        </td>
                    ))}
                </tr>
                <tr>
                    <td style={{ padding: "12Px" }}>
                        Evaluasi Keperawatan
                    </td>
                    {details.map(v => (
                        <td style={{ padding: "12Px" }}>
                            {" "}
                            {v.anamneses.length > 0
                                ? v.anamneses[0].eval
                                : ""}{" "}
                        </td>
                    ))}
                </tr>
                </tbody>
            </table>
        )
    }

    return (
        <div>
            <div className="card">
                <div className="card-header">
                    <h3>Histori Pelayanan</h3>
                </div>
                <div className="card-body">
                    <div className="accordion" id="accordionRiwo">
                        {histories.map((history, key) => (
                            <div className="card" key={key}>
                                <div
                                    className="card-header"
                                    id={"headingRiwo" + key}
                                    data-toggle="collapse"
                                    data-target={"#collapseRiwo" + key}
                                    aria-expanded="false"
                                    aria-controls={"collapseRiwo" + key}
                                >
                                    <div className="text-primary h4">
                                        {/*POLIKLINIK{" "}*/}
                                        {/*{history.clinics !== null*/}
                                        {/*    ? history.clinics.name.toUpperCase()*/}
                                        {/*    : ""}*/}
                                    </div>
                                    {history.inpatient.inpatient_rooms.map(v => v.dpjp.name).join()}
                                    <mark>
                                        <em>
                                            {moment(history.inpatient.entry_date).format("DD-MM-YYYY HH:mm:ss")} sd {history.inpatient.exit_date ? moment(history.inpatient.exit_date).format("DD-MM-YYYY HH:mm:ss") : 'Sekarang'}
                                        </em>
                                    </mark>
                                </div>
                                <div
                                    id={"collapseRiwo" + key}
                                    className="collapse"
                                    aria-labelledby={"headingRiwo" + key}
                                >
                                    <div
                                        className="card-body"
                                        // ref={(el) => (this[`componentRef${key}`] = el)}
                                    >
                                        {build_pelayanan_utama(history.inpatient.inpatient_rooms.reverse())}
                                        <br></br>
                                        <br></br>
                                        {/*<table className="table table-striped table-bordered col-md-12">*/}
                                        {/*    <tbody>*/}
                                        {/*    <tr className="bg-secondary">*/}
                                        {/*        <th style={{padding: "12Px"}} colSpan={2}>*/}
                                        {/*            <div className="text-black text-center h4">*/}
                                        {/*                PELAYANAN PENUNJANG*/}
                                        {/*            </div>*/}
                                        {/*        </th>*/}
                                        {/*    </tr>*/}
                                        {/*    {history.labs[0] ? (*/}
                                        {/*        history.labs[0].details.map((s, k) => {*/}
                                        {/*            return s.log ? (*/}
                                        {/*                <tr key={k}></tr>*/}
                                        {/*            ) : (*/}
                                        {/*                <tr key={k}>*/}
                                        {/*                    <th style={{padding: "12Px"}}>*/}
                                        {/*                        Pemeriksaan {s.lab.category.name} |{" "}*/}
                                        {/*                        {s.lab.name}*/}
                                        {/*                    </th>*/}
                                        {/*                    <td style={{padding: "12Px"}}>*/}
                                        {/*                        {s.result + " " + s.lab.unit}*/}
                                        {/*                    </td>*/}
                                        {/*                </tr>*/}
                                        {/*            );*/}
                                        {/*        })*/}
                                        {/*    ) : (*/}
                                        {/*        <tr>*/}
                                        {/*            <td className="text-center" colSpan={2}>*/}
                                        {/*                Data tidak ditemukan*/}
                                        {/*            </td>*/}
                                        {/*        </tr>*/}
                                        {/*    )}*/}
                                        {/*    </tbody>*/}
                                        {/*</table>*/}
                                    </div>
                                    <button
                                        className="btn btn-success"
                                        onClick={() => BlobPrint(`registration/inpatient/history/soap/print/${history.id}`)}
                                    >
                                        Cetak SOAP
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="datatable-buttons_paginate"
                    >
                        <ReactPaginate
                            previousLabel={"<"}
                            previousClassName={"paginate_button page-item previous"}
                            previousLinkClassName={"page-link"}
                            nextLabel={">"}
                            nextClassName={"paginate_button page-item  next"}
                            nextLinkClassName={"page-link"}
                            breakLabel={"..."}
                            pageClassName={"paginate_button page-item"}
                            pageLinkClassName={"page-link"}
                            pageCount={datas.last_page}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(e) => changePage(e.selected + 1)}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                        />
                    </div>
                </div>

                <div className="card-footer">
                    <button className="btn btn-danger" onClick={onReload}>
                        Tutup
                    </button>
                </div>
            </div>
        </div>
    )
}